import { render, staticRenderFns } from "./ServiceManagementDetail.vue?vue&type=template&id=2d4eaa37&scoped=true"
import script from "./ServiceManagementDetail.vue?vue&type=script&lang=js"
export * from "./ServiceManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceManagementDetail.vue?vue&type=style&index=0&id=2d4eaa37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4eaa37",
  null
  
)

export default component.exports